import Applications from './Applications';
import ApplicationsWidget from './ApplicationsWidget';

export { ApplicationsWidget };
export default Applications;
